<it-card teaser="true" shadow="true">
  <div class="row">
    <div class="col">
      <it-alert color="primary" > 
        Da questa pagina è possibile inserire la data e l'ora di dimissione effettiva.
      </it-alert>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <div class="mt-2">
        <it-input [(ngModel)]="dischargeDate" type="date" label="Data di dimissione"></it-input>
      </div>
      <div class="mt-2">
        <it-input [(ngModel)]="dischargeTime" type="time" label="Ora di dimissione"></it-input>
      </div>
      <div class="mt-2">
        <it-textarea
            [rows]="5"
            description="Nota"
            [(ngModel)]="note"
        ></it-textarea>
      </div>
    
      <div class="d-flex justify-content-end gap-2 mt-4">
        <button 
            itButton="outline-primary" 
            type="button" 
            (click)="cancel()">
          Torna indietro
        </button>
        <button
          itButton="success"
          type="button"
          [disabled]="!dischargeDate || !dischargeTime"
          (click)="confirm()"
        >
          Conferma
        </button>
      </div>
    </div>
  </div>    
  </it-card>
  